import React from "react";
import { Sidebar } from "primereact/sidebar";
import { FaChevronDown } from "react-icons/fa";
import Select from "react-select";
import { userRole } from "../Constant/Constant";

const PipelineFilter = ({
  visible,
  onHide,
  teams,
  selectedTeam,

  handleTeamChange,
  handlePropertyChange,
  selectedProperty,
  properties,
  users,
  handleUserChange,
  selectedUser,
  handleApplyFilter,
  clearFilters,

  errors,
}) => {
  const options = users.map((user) => ({
    value: user.id,
    label: user.name,
  }));

  return (
    <>
      <Sidebar
        header={
          <div className="flex align-items-center gap-2">
            <span className="font-bold">Pipeline Filter</span>
          </div>
        }
        visible={visible}
        onHide={onHide}
        position="right"
      >
        <div className="border-2 border-slate-200 rounded-md p-3 flex flex-col gap-4 ">
          {/* Team */}
          <div className="w-full cursor-pointer relative">
            <select
              className={`appearance-none cursor-pointer w-full shadow border-2 border-customGreen rounded-md py-2 px-3 text-gray-700 `}
              onChange={(e) => handleTeamChange(e.target.value)}
              value={selectedTeam}
              disabled={!!selectedUser}
            >
              <option value="">Select Team</option>
              {teams.map((team) => (
                <option key={team.id} value={team.id}>
                  {team.name}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center px-2 text-customGreen">
              <FaChevronDown />
            </div>
          </div>

          {/* Preperty */}
          <div className="w-full cursor-pointer relative">
            <select
              className={`appearance-none cursor-pointer w-full shadow border-2 border-customGreen rounded-md py-2 px-3 text-gray-700 ${
                errors.properties && "border-red-500"
              }`}
              onChange={(e) => handlePropertyChange(e.target.value)}
              value={selectedProperty}
              disabled={!!selectedUser}
            >
              <option value="">Select Property</option>
              {properties.map((property) => (
                <option key={property.id} value={property.id}>
                  {property.name}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center px-2 text-customGreen">
              <FaChevronDown />
            </div>
          </div>
        </div>

        {(userRole === "Admin" || userRole ==="CMO")  && (
          <>
            <div class="inline-flex items-center justify-center w-full">
              <hr class="w-64 h-px my-8 bg-gray-400 border-0 " />
              <span class="absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2">
                or
              </span>
            </div>

            {/* User */}
            <div className="w-full cursor-pointer relative p-3">
              <Select
                className={`appearance-none cursor-pointer w-full shadow border-2 border-customGreen rounded-md  text-gray-700 `}
                options={options}
                onChange={(selectedOption) =>
                  handleUserChange(selectedOption?.value)
                }
                value={
                  options.find((opt) => opt.value === selectedUser) || null
                }
                placeholder="Select User"
                isClearable
                isDisabled={!!selectedTeam || !!selectedProperty}
              />
            </div>
          </>
        )}

        <div className="flex flex-col gap-4 p-3 bottom-0">
          <button
            className="bg-customGreen text-white py-2 px-4 rounded-md hover:bg-appGreenHover transition duration-300 w-full mt-4"
            onClick={handleApplyFilter}
          >
            Apply Filters
          </button>
          <button
            className="bg-white text-customGreen border border-customGreen py-2 px-4 rounded-md hover:bg-gray-100 transition duration-300 w-full"
            onClick={clearFilters}
          >
            Clear Filters
          </button>
        </div>
      </Sidebar>
    </>
  );
};

export default PipelineFilter;
